// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cc9CX","image":"styles_image__cnGZJ","cropped":"styles_cropped__7OvOb"};